import { merge } from 'lodash';
import { UploadContractsMachine } from '~/machines/upload-contracts';
import { ContextSendMatch } from '~/machines/utils/types';
import { DeepPartial } from '~/typings/utils';
import { ContractsUpload, ContractsUploadProps } from './contracts-upload.component';

type ContractsUploadContainerProps = {
  micro: ContextSendMatch<UploadContractsMachine>;
  overrideCopy?: ContractsUploadProps['overrideCopy'];
  overrideProps?: DeepPartial<ContractsUploadProps>;
};

export const ContractsUploadContainer = ({
  micro: { context, matches, send },
  overrideCopy,
  overrideProps,
}: ContractsUploadContainerProps) => {
  const props: ContractsUploadProps = {
    context: {
      funnelPacket: context.funnelPacket,
      docuSignContracts: context.docuSignContracts,
      vnmSolarProjectContracts: context.vnmSolarProjectContracts,
    },
    externalSystem: context.externalSystem,
    loading: matches('uploadContracts.fetching'),
    next: () => send({ type: 'SUBMIT_CONTRACTS' }),
    overrideCopy,
  };

  return <ContractsUpload {...merge(props, overrideProps)} />;
};
